import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { Button } from 'reactstrap';

import FromTo from './FromTo';
import { padSAtTheEndIfPlural } from '../../../lib/helpers';
import { injectTransportationSearchParams } from '../Common';
import config from '../../../config';

function TransportationCard(props) {
  const { data, isRoundTrip, queryParams } = props;
  const {
    vehicleType,
    mode,
    departureTime,
    arrivalTime,
    price: { currency, amount },
    inclusions,
    duration,
    capacity,
    distance,
    departFrom,
    coverImages,
    id,
  } = data;
  const { pax, fromLocation, toLocation } = queryParams;
  const isPrivate = mode.toLowerCase() === 'private';


  const handleClick = async e => {
    e.preventDefault();
    const { history, location: { search } } = props;
    history.push('/transportation/details' + search + `&id=${id}`);
  };

  let totalPrice = isPrivate ? amount : Number(amount) * Number(pax);
  totalPrice = isRoundTrip ? totalPrice * 2 : totalPrice;

  return (
    <a onClick={handleClick} id="transportation-book-now-btn">
      <div className="search__card lodge trans">
        <section className="lodge__image">
          <img
            alt={[fromLocation, toLocation].join(' - ')}
            src={`${config.ASSETS_URL}${coverImages}`}
          />
        </section>

        <section className="lodge__information">
          <div className="lodge_name_location">
            <h3 className="lodge_name">{vehicleType}</h3>
            <div className="lodge_included">
              <ul>{!isEmpty(inclusions) && <li>Includes: {inclusions.join(', ')}</li>}</ul>
            </div>
          </div>
          <div className="transport_times">
            <div className="one-way">
              <FromTo
                fromTo={[fromLocation, toLocation].join(' - ')}
                departureTime={departureTime}
                arrivalTime={arrivalTime}
                distance={distance}
                duration={duration}
                departFrom={departFrom && departFrom[fromLocation]}
              />
            </div>
            <div className="two_way">{isRoundTrip ? 'Round Trip' : 'One Way'}</div>
          </div>
          <ul className="transport_higlight small-size">
            <li>* Free 48 hours cancellation</li>
            <li>* 24/7 Customer Support</li>
          </ul>
        </section>

        <section className="lodge__summary">
          <p className="lodge_info_cost">
            {currency} {totalPrice.toLocaleString()}
          </p>
          <p style={{marginBottom: '0px'}}><strong>{mode}</strong></p>
          <ul className="transport_higlight">
            <li>
              {isRoundTrip ? `Both Way Price for ${getPeopleNumStr(pax)}` : `One Way Price for ${getPeopleNumStr(pax)}`}
            </li>
            {isPrivate && <li>Space for {getPeopleNumStr(capacity)}</li>}
          </ul>
          <Button color="yellow" id="transport-select-btn">
            View Details
          </Button>
        </section>
      </div>
    </a>
  );
}

export const getPeopleNumStr = peopleNum =>
  `${peopleNum} ${padSAtTheEndIfPlural(peopleNum, 'passenger')}`;


export default injectTransportationSearchParams(TransportationCard);



// WEBPACK FOOTER //
// ./src/screens/Transportation/TransportationList/TransportationCard.js